import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const WONDER_BASE_URL = 'https://wonder.kevinvandertoorn.com';

const preloadImage = (src) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = resolve;
    img.onerror = reject;
    img.src = src;
  });
};

const initialState = {
  id: null,
  foreground: null,
  background: null,
  color: null,
  name: null,
  in_rotation: null,
  created_at: null,
  isTransitioning: false,
  isInitialLoad: true,
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    themeTransitionStart(state) {
      state.isTransitioning = true;
    },
    themeReceived(state, action) {
      Object.assign(state, action.payload);
      state.isTransitioning = false;
      state.isInitialLoad = false;
    },
    themeGetError(state) {
      state.isTransitioning = false;
    },
  },
});

export const { themeTransitionStart, themeReceived, themeGetError } = themeSlice.actions;

export const getTheme = () => (dispatch, getState) => {
  const url = 'https://wonder.kevinvandertoorn.com/octo-dashboard/api/get-theme/';

  dispatch(themeTransitionStart());

  const loadTheme = async () => {
    try {
      const { data } = await axios.get(url);

      await Promise.all([
        preloadImage(WONDER_BASE_URL + data.background),
        preloadImage(WONDER_BASE_URL + data.foreground),
      ]);

      dispatch(themeReceived(data));
    } catch (error) {
      dispatch(themeGetError());
    }
  };

  loadTheme();
};

export default themeSlice.reducer;


